<app-template-text [value]="value" [control]="control" [label]="label" [disabled]="disabled" />
